
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import './ExamPage.css';
// import { useLocation, useNavigate } from 'react-router-dom';

// const ExamPage = () => {
//   const location = useLocation();
//   const studentId = location.state?.studentid;
//   const [questions, setQuestions] = useState([]);
//   const [answers, setAnswers] = useState({});
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [timeLeft, setTimeLeft] = useState(0);
//   const [submitted, setSubmitted] = useState(false);
//   const [examCompleted, setExamCompleted] = useState(false);
//   const [score, setScore] = useState(null);
//   const [timeTaken, setTimeTaken] = useState('');
//   const [isGov, setIsGov] = useState(false);
//   const [startTime, setStartTime] = useState(null);
//   const [isSaving, setIsSaving] = useState(false); // 🆕 Added
//   const [wrongAnswer,setwrongAnswer]=useState(null);
//   const [question_index,setquestion_index]=useState(null)
//   const navigate = useNavigate();

//   const EXAM_DURATION = 60 * 60 * 1000;
//   const userId = studentId;
//   const STORAGE_KEY_INDEX = `current_index_${userId}`;

//   useEffect(() => {
//     const checkExamStatus = async () => {
//       try {
//         const response = await axios.post(`${process.env.REACT_APP_API}/students/enterexam`, {
//           studentid: studentId
//         });
//         // console.log(response.data)

//         if (response.data.completed) {
//           setExamCompleted(true);
//           setScore(response.data.score || 0);
//           setTimeTaken(response.data.timeTaken || '00:00');
//           setwrongAnswer(response.data.wronganswer || 0);
//           // console.log(response.data.wronganswer)
//         } else {
        
//           if (response.data.startTime) {
//             setStartTime(new Date(response.data.startTime));
//             // console.log(response.data)
//           }
//           if(response.data.index){
//             setquestion_index(response.data.index)
//             console.log(response.data.index)
//           }
//         }
//       } catch (error) {
//         alert(error.response?.data?.message || "Something went wrong");
//       }
//     };

//     if (studentId) checkExamStatus();
//   }, [studentId]);

//   useEffect(() => {
//     axios.get(`${process.env.REACT_APP_API}/questions/getexamquestions/${userId}`)
//       .then(res => {
//         setQuestions(res.data);
//         const savedIndex = parseInt(localStorage.getItem(STORAGE_KEY_INDEX), 10);
//         if (!isNaN(savedIndex) && savedIndex < res.data.length) {
//           setCurrentIndex(savedIndex);
//         }
//       })
//       .catch(err => {
//         if (err.response && err.response.status === 402) {
//           setIsGov(true);
//         } else {
//           console.error(err);
//         }
//       });
//   }, [userId]);

//   useEffect(() => {
//     if (!startTime || submitted) return;

//     const startTimestamp = new Date(startTime).getTime();

//     const interval = setInterval(() => {
//       const now = Date.now();
//       const elapsed = now - startTimestamp;
//       const remaining = Math.floor((EXAM_DURATION - elapsed) / 1000);

//       if (remaining <= 0) {
//         clearInterval(interval);
//         setTimeLeft(0);
//         handleSubmit();
//         navigate('/');
//       } else {
//         setTimeLeft(remaining);
//       }
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [startTime, submitted, navigate]);

//   const formatTime = (seconds) => {
//     const min = Math.floor(seconds / 60).toString().padStart(2, '0');
//     const sec = (seconds % 60).toString().padStart(2, '0');
//     return `${min}:${sec}`;
//   };

//   const handleOptionChange = (questionId, selectedOption) => {
//     setAnswers(prev => ({ ...prev, [questionId]: selectedOption }));
//   };

//   const saveAnswerToDB = async (questionId, selectedOption) => {
//     try {
//       await axios.post(`${process.env.REACT_APP_API}/questions/save-answer`, {
//         studentId: userId,
//         questionId,
//         selectedOption,
//       });
//     } catch (err) {
//       console.error('Error saving answer:', err);
//     }
//   };

//   const handleNext = async () => {
//     if (isSaving) return; // 🛑 Prevent rapid multiple clicks

//     const question = questions[currentIndex];
//     const selectedOption = answers[question.id];
//     if (!selectedOption) return;

//     try {
//       setIsSaving(true); // 🔒 Disable while saving
//       await saveAnswerToDB(question.id, selectedOption);

//       if (currentIndex < questions.length - 1) {
//         const newIndex = currentIndex + 1;
//         setCurrentIndex(newIndex);
//         localStorage.setItem(STORAGE_KEY_INDEX, newIndex);
//       }

//       if (!startTime) {
//         setStartTime(new Date());
//       }
//     } catch (err) {
//       console.error("Error saving answer:", err);
//       alert("Failed to save answer. Please try again.");
//     } finally {
//       setIsSaving(false); // 🔓 Re-enable after saving
//     }
//   };

//   const handleSubmit = async () => {
//     setSubmitted(true);
//     localStorage.removeItem(STORAGE_KEY_INDEX);

//     try {
//       const question = questions[currentIndex];
//       const selectedOption = answers[question?.id];

//       if (question && selectedOption) {
//         await saveAnswerToDB(question.id, selectedOption);
//       }

//       const totalSeconds = Math.floor((EXAM_DURATION - timeLeft * 1000) / 1000);
//       const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
//       const seconds = (totalSeconds % 60).toString().padStart(2, '0');
//       const timeTakenFormatted = `${minutes}:${seconds}`;

//       await axios.post(`${process.env.REACT_APP_API}/questions/submit-exam`, {
//         studentId: userId,
//         markCompleted: true,
//         timeTaken: timeTakenFormatted,
//       });

//       alert('Exam submitted');
//       setExamCompleted(true);
//       window.location.reload();
//     } catch (error) {
//       console.error(error);
//       alert('Failed to submit exam.');
//     }
//   };

//   if (examCompleted) {
//     return (
//       <div className="exam-complete-card">
//         <div className="exam-status-icon">✅</div>
//         <h2 className="exam-status-title">You’ve Successfully Completed Your Exam!</h2>
//         <div className="exam-details">
//           <p><span className="label">🎯 Exam Mark:</span> <span className="value mark">{score}</span></p>
//           <p><span className="label">❌ Wrong Answers:</span> <span style={{color:'red'}} className="value mark">{wrongAnswer}</span></p>
//           <p><span className="label">⏱️ Time Taken:</span> <span className="value time">{timeTaken}</span></p>
//         </div>
//         <button className="btn btn-primary" onClick={() => navigate('/profile')}>Go to Profile</button>
//       </div>
//     );
//   }

//   if (questions.length === 0) {
//     if (isGov) {
//       return <h1 style={{ textAlign: 'center', marginTop: '50px' }}>Exam conducting only for classes VI to XII.</h1>;
//     }
//     return <p style={{ textAlign: 'center', marginTop: '50px' }}>Loading questions...</p>;
//   }

//   const currentQuestion = questions[currentIndex];
//   const selectedAnswer = answers[currentQuestion?.id];

//   return (
//     <div className="exam-container">
//       <div className="exam-header">
//         <h2>📘 Online Exam</h2>
//         <h3 className={`timer ${timeLeft <= 60 ? 'warning' : ''}`}>
//           ⏰ Time Left: {formatTime(timeLeft)}
//         </h3>
//       </div>

//       <div className="progress-bar">
//         <div
//           className="progress-bar-fill"
//           style={{ width: `${((currentIndex + 1) / questions.length) * 100}%` }}
//         />
//       </div>

//       <p className="question-number">
//         Question {currentIndex + 1} of {questions.length}
//       </p>

//       <div>
//         <h4 className="question-text">{currentQuestion.question}</h4>
//         {['option_a', 'option_b', 'option_c', 'option_d'].map(opt => (
//           <label
//             key={`${currentQuestion.id}_${opt}`}
//             className={`option-label ${selectedAnswer === opt ? 'selected' : ''}`}
//           >
//             <input
//               type="radio"
//               name={`q${currentQuestion.id}`}
//               value={opt}
//               checked={selectedAnswer === opt}
//               onChange={() => handleOptionChange(currentQuestion.id, opt)}
//             />
//             {currentQuestion[opt]}
//           </label>
//         ))}
//       </div>

//       <div className="nav-buttons">
//         {currentIndex === questions.length - 1 ? (
//           <button
//             className="btn btn-submit"
//             onClick={handleSubmit}
//             disabled={submitted || !selectedAnswer}
//           >
//             Submit Exam
//           </button>
//         ) : (
//           <button
//             className="btn btn-next"
//             onClick={handleNext}
//             disabled={!selectedAnswer || isSaving}
//           >
//             {isSaving ? 'Saving...' : 'Next'}
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ExamPage;









import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ExamPage.css';
import { useLocation, useNavigate } from 'react-router-dom';

const ExamPage = () => {
  const location = useLocation();
  const studentId = location.state?.studentid;
  const examtypeid  =location.state?.examtypeid;

  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [examCompleted, setExamCompleted] = useState(false);
  const [score, setScore] = useState(null);
  const [timeTaken, setTimeTaken] = useState('');
  const [isGov, setIsGov] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [wrongAnswer, setWrongAnswer] = useState(null);
  const [question_index, setquestion_index] = useState(null);

  const navigate = useNavigate();

  const EXAM_DURATION = 60 * 60 * 1000;
  const userId = studentId;

  useEffect(() => {
    // console.log(examtypeid)
    const checkExamStatus = async () => {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API}/students/enterexam`, {
          studentid: studentId,
          examtype :examtypeid,
        });

        if (response.data.completed) {
          setExamCompleted(true);
          setScore(response.data.score || 0);
          setTimeTaken(response.data.timeTaken || '00:00');
          setWrongAnswer(response.data.wronganswer || 0);
        } else {
          if (response.data.startTime) {
            setStartTime(new Date(response.data.startTime));
          }
          if (response.data.index !== undefined) {
            setquestion_index(response.data.index);
          }
        }
      } catch (error) {
        alert(error.response?.data?.message || "Something went wrong");
      }
    };

    if (studentId) checkExamStatus();
  }, [studentId]);

useEffect(() => {
  axios.get(`${process.env.REACT_APP_API}/questions/getexamquestions/${userId}`, {
    params: {
      examtypeid: examtypeid
    }
  })
    .then(res => {
      setQuestions(res.data);
      if (question_index !== null && question_index < res.data.length) {
        setCurrentIndex(question_index);
      }
    })
    .catch(err => {
      if (err.response && err.response.status === 402) {
        setIsGov(true);
      } else {
        console.error(err);
      }
    });
}, [userId, question_index, examtypeid]); // added examTypeId to dependencies

  useEffect(() => {
    if (!startTime || submitted) return;

    const startTimestamp = new Date(startTime).getTime();

    const interval = setInterval(() => {
      const now = Date.now();
      const elapsed = now - startTimestamp;
      const remaining = Math.floor((EXAM_DURATION - elapsed) / 1000);

      if (remaining <= 0) {
        clearInterval(interval);
        setTimeLeft(0);
        handleSubmit();
        // navigate('/');
      } else {
        setTimeLeft(remaining);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime, submitted, navigate]);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60).toString().padStart(2, '0');
    const sec = (seconds % 60).toString().padStart(2, '0');
    return `${min}:${sec}`;
  };

  const handleOptionChange = (questionId, selectedOption) => {
    setAnswers(prev => ({ ...prev, [questionId]: selectedOption }));
  };

  const saveAnswerToDB = async (questionId, selectedOption) => {
    try {
      await axios.post(`${process.env.REACT_APP_API}/questions/save-answer`, {
        studentId: userId,
        questionId,
        selectedOption,
        examtypeid
      });
    } catch (err) {
      console.error('Error saving answer:', err);
    }
  };

  const handleNext = async () => {
    if (isSaving) return;

    const question = questions[currentIndex];
    const selectedOption = answers[question.id];
    if (!selectedOption) return;

    try {
      setIsSaving(true);
      await saveAnswerToDB(question.id, selectedOption);

      if (currentIndex < questions.length - 1) {
        const newIndex = currentIndex + 1;
        setCurrentIndex(newIndex);
        setquestion_index(newIndex);
      }

      if (!startTime) {
        setStartTime(new Date());
      }
    } catch (err) {
      console.error("Error saving answer:", err);
      alert("Failed to save answer. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleSubmit = async () => {
    setSubmitted(true);
    setquestion_index(null); // Clear the index

    try {
      const question = questions[currentIndex];
      const selectedOption = answers[question?.id];

      if (question && selectedOption) {
        await saveAnswerToDB(question.id, selectedOption);
      }

      const totalSeconds = Math.floor((EXAM_DURATION - timeLeft * 1000) / 1000);
      const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
      const seconds = (totalSeconds % 60).toString().padStart(2, '0');
      const timeTakenFormatted = `${minutes}:${seconds}`;

      await axios.post(`${process.env.REACT_APP_API}/questions/submit-exam`, {
        studentId: userId,
        markCompleted: true,
        timeTaken: timeTakenFormatted,
      });

      alert('Exam submitted');
      // setExamCompleted(true);
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert('Failed to submit exam.');
    }
  };

  if (examCompleted) {
    return (
      <div className="exam-complete-card">
        <div className="exam-status-icon">✅</div>
        <h2 className="exam-status-title">You’ve Successfully Completed Your Exam!</h2>
        <div className="exam-details">
          <p><span className="label">🎯 Exam Mark:</span> <span className="value mark" style={{backgroundColor:"transparent"}}>{score}</span></p>
          <p><span className="label">❌ Wrong Answers:</span> <span style={{ color: 'red' ,backgroundColor:"transparent"}} className="value mark">{wrongAnswer}</span></p>
          <p><span className="label">⏱️ Time Taken:</span> <span className="value time" >{timeTaken}</span></p>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/profile')}>Go to Profile</button>
      </div>
    );
  }
  if (questions.length === 0) {
    if (isGov) {
      return <h1 style={{ textAlign: 'center', marginTop: '50px' }}>Exam conducting only for classes VI to XII.</h1>;
    }
    return <p style={{ textAlign: 'center', marginTop: '50px' }}>Loading questions...</p>;
  }

  const currentQuestion = questions[currentIndex];
  const selectedAnswer = answers[currentQuestion?.id];

  return (
    <div className="exam-container">
      <div className="exam-header">
        <h2>📘 Online Exam</h2>
        <h3 className={`timer ${timeLeft <= 60 ? 'warning' : ''}`}>
          ⏰ Time Left: {formatTime(timeLeft)}
        </h3>
      </div>

      <div className="progress-bar">
        <div
          className="progress-bar-fill"
          style={{ width: `${((currentIndex + 1) / questions.length) * 100}%` }}
        />
      </div>

      <p className="question-number">
        Question {currentIndex + 1} of {questions.length}
      </p>

      <div>
        <h4 className="question-text">{currentQuestion.question}</h4>
        {['option_a', 'option_b', 'option_c', 'option_d'].map(opt => (
          <label
            key={`${currentQuestion.id}_${opt}`}
            className={`option-label ${selectedAnswer === opt ? 'selected' : ''}`}
          >
            <input
              type="radio"
              name={`q${currentQuestion.id}`}
              value={opt}
              checked={selectedAnswer === opt}
              onChange={() => handleOptionChange(currentQuestion.id, opt)}
            />
            {currentQuestion[opt]}
          </label>
        ))}
      </div>

      <div className="nav-buttons">
        {currentIndex === questions.length - 1 ? (
          <button
            className="btn btn-submit"
            onClick={handleSubmit}
            disabled={submitted || !selectedAnswer}
          >
            Submit Exam
          </button>
        ) : (
          <button
            className="btn btn-next"
            onClick={handleNext}
            disabled={!selectedAnswer || isSaving}
          >
            {isSaving ? 'Saving...' : 'Next'}
          </button>
        )}
      </div>
    </div>
  );
};

export default ExamPage;
